import { shouldShowRetryBanner } from '../../ChatDrawer.hooks'
import { useChatSuggestionsPreferences } from './useChatSuggestionsPreferences'
import { useMessageSuggestions } from './useMessageSuggestions'

interface UseAreSuggestionsVisibleOptions {
  messages: any[]
  websocketAvailable: boolean
  showLoader?: boolean
  retryPending?: { messageIndex: number } | null
  sendFailed?: boolean
}

export const useAreSuggestionsVisible = (options: UseAreSuggestionsVisibleOptions): boolean => {
  const { messages, websocketAvailable, showLoader = false, retryPending, sendFailed = false } = options
  const suggestionKeys = useMessageSuggestions()
  const { preferences } = useChatSuggestionsPreferences()

  const showChatSuggestions =
    messages.length === 0 &&
    !showLoader &&
    suggestionKeys.length > 0 &&
    websocketAvailable &&
    preferences.showSuggestionsOnEmptyChat

  const showCompactSuggestions =
    messages.length > 0 &&
    suggestionKeys.length > 0 &&
    preferences.showCompactSuggestions &&
    websocketAvailable &&
    !sendFailed &&
    !shouldShowRetryBanner(retryPending, websocketAvailable)

  return showChatSuggestions || showCompactSuggestions
}
